import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home/index.vue'
import Test from '../views/Home/test.vue'
//产品资讯
import Products from '../views/ConstProducts/index.vue'
import Caichan from '../views/ConstProducts/Caichan.vue'
import Ruanjian from '../views/ConstProducts/Ruanjian.vue'
import Xinxi from '../views/ConstProducts/Xinxi.vue'
import CheHua1 from '../views/ConstProducts/CheHua1.vue'
import Qiye1 from '../views/ConstProducts/Qiye1.vue'
import ShangWu1 from '../views/ConstProducts/ShangWu1.vue'
import ShuiWu1 from '../views/ConstProducts/ShuiWu1.vue'
//直播微课
import Zhibo from '../views/Zhibo/index.vue'
import Xiangqin from '@/views/Zhibo/xiangqin.vue'
//行业案例
import IndustryCases from '@/views/IndustryCases/index.vue'
import Cases from '@/views/IndustryCases/Cases.vue'
//了解更多
import About from '@/views/More/About.vue'
import Daili from '@/views/More/Daili.vue'
import News from '@/views/More/News.vue'
import Newsx from '@/views/More/Newsx.vue'
//联系我们
import Contact from '@/views/Contact/index.vue'
import Recruit from '@/views/Contact/Recruit.vue'
//服务流程
import Service from '@/views/Servicess/index.vue'
import PeiXun from '@/views/Servicess/PeiXun.vue'
import ShangWU from '@/views/Servicess/ShangWU.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
  },
  {
    path: '/test',
    name: 'Test',
    component: Test,
  },

  // 产品资讯
  {
    path: '/products',
    name: 'Products',
    component: Products,
  },
  {
    path: '/caichan',
    name: 'Caichan',
    component: Caichan,
  },
  {
    path: '/ruanjian',
    name: 'Ruanjian',
    component: Ruanjian,
  },
  {
    path: '/xinxi',
    name: 'Xinxi',
    component: Xinxi,
  },
  {
    path: '/chehua1',
    name: 'CheHua1',
    component: CheHua1,
  },
  {
    path: '/Qiye1',
    name: 'Qiye1',
    component: Qiye1,
  },
  {
    path: '/shangwu1',
    name: 'ShangWu1',
    component: ShangWu1,
  },
  {
    path: '/shuiwu1',
    name: 'ShuiWu1',
    component: ShuiWu1,
  },

  // 产品资讯end----------------

  // 直播路由
  {
    path: '/zhibo',
    name: 'Zhibo',
    component: Zhibo,
  },

  {
    path: '/xiangqin',
    name: 'Xiangqin',
    component: Xiangqin,
  },
  // 直播路由 end-------------------------

  // 行业案例
  {
    path: '/industrycases',
    name: 'IndustryCases',
    component: IndustryCases,
  },
  {
    path: '/cases',
    name: 'Cases',
    component: Cases,
  },

  // 行业案例end------------

  //了解更多
  {
    path: '/about',
    name: 'About',
    component: About,
  },

  {
    path: '/daili',
    name: 'Daili',
    component: Daili,
  },

  {
    path: '/news',
    name: 'News',
    component: News,
  },

  {
    path: '/newsx',
    name: 'Newsx',
    component: Newsx,
  },

  //了解更多 end---------------------

  //关于我们
  {
    path: '/contact',
    name: 'Contact',
    component: Contact,
  },

  {
    path: '/recruit',
    name: 'Recruit',
    component: Recruit,
  },

  //关于我们end------------------

  //服务流程
  {
    path: '/service',
    name: 'Service',
    component: Service,
  },
  {
    path: '/peixun',
    name: 'PeiXun',
    component: PeiXun,
  },
  {
    path: '/shangwu',
    name: 'ShangWU',
    component: ShangWU,
  },
]

const router = new VueRouter({
  // mode: 'history',
  base: process.env.BASE_URL,
  routes,
})

export default router
